import { Col, DatePicker, Input } from 'antd'
import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'
import CIMSRangeGroup from 'components/CIMSRangeGroup'
import CIMSFormItemList from 'components/CIMSFormItemList'

const help = HelpMessage.Materials.Concrete

export const RequiredFields: React.FC = () => {
  return (
    <>
      <Col xs={24} xl={12} xxl={8}>
        <CIMSFormItem
          name="mixDesignNumber"
          label="Mix Design Number"
          requiredMessage="Please enter a Mix Design Number"
          help={help.Number}
        >
          <Input allowClear />
        </CIMSFormItem>
      </Col>
      <Col xs={24} xl={12} xxl={8}>
        <CIMSFormItem
          name="materialSource"
          label="Supplier"
          requiredMessage="Please enter a supplier"
          help={help.Source}
        >
          <Input allowClear />
        </CIMSFormItem>
      </Col>
      <Col xs={24} xl={12} xxl={8}>
        <CIMSFormItem
          name="class"
          label="Class"
          requiredMessage="Please enter a class"
          help={help.Class}
        >
          <Input allowClear />
        </CIMSFormItem>
      </Col>
      <Col xs={24} xl={12} xxl={8}>
        <CIMSFormItem
          name="expirationDate"
          label="Expiration Date"
          help={help.ExpirationDate}
          requiredMessage="Please enter an expiration date"
        >
          <DatePicker allowClear style={{ width: '100%' }} />
        </CIMSFormItem>
      </Col>
      <Col xs={24} xl={12} xxl={8}>
        <CIMSFormItem
          name="wc"
          label="W/C Ratio"
          requiredMessage="Please enter a W/C ratio"
          help={help.WC}
        >
          <Input allowClear />
        </CIMSFormItem>
      </Col>
      <Col xs={24} xl={12} xxl={8}>
        <CIMSFormItem
          name="admixtures"
          label="Admixtures"
          requiredMessage="Please enter admixtures"
          help={help.Admixtures}
        >
          <Input allowClear />
        </CIMSFormItem>
      </Col>
      <Col xs={24} xl={12} xxl={8}>
        <CIMSRangeGroup
          name="slump"
          label="Slump Range"
          help={help.Slump}
          required
        />
      </Col>
      <Col xs={24} xl={12} xxl={8}>
        <CIMSRangeGroup name="air" label="Air Range" help={help.Air} required />
      </Col>
      <Col xs={24} xl={12} xxl={8}>
        <CIMSFormItem
          name="maxAggSize"
          label="Max Agg Size"
          requiredMessage="Please enter max agg size"
          help={help.MaxAggSize}
        >
          <Input allowClear />
        </CIMSFormItem>
      </Col>
    </>
  )
}

export const OptionalFields: React.FC = () => {
  return (
    <>
      <Col xs={24} xl={12}>
        <CIMSFormItem
          name="submittalId"
          label="Submittal ID"
          help={help.SubmittalID}
        >
          <Input allowClear />
        </CIMSFormItem>
      </Col>
      <Col xs={24} xl={12}>
        <CIMSFormItem name="concreteUse" label="Use" help={help.Use}>
          <Input allowClear />
        </CIMSFormItem>
      </Col>
    </>
  )
}

export const AggregateFields: React.FC = () => {
  return (
    <Col xs={24}>
      <CIMSFormItemList
        name="aggregates"
        label="Aggregate"
        buttons={[
          {
            icon: 'add',
            hideAfter: 3,
            add: () => '',
          },
        ]}
        rowOptions={{
          showDeleteAfter: 2,
        }}
      >
        {(name) => (
          <Col flex="auto">
            <CIMSFormItem
              label="Name"
              name={name}
              requiredMessage="Please enter an aggregate"
            >
              <Input allowClear />
            </CIMSFormItem>
          </Col>
        )}
      </CIMSFormItemList>
    </Col>
  )
}
